import React, { PureComponent, Fragment } from 'react'

import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Wrapper from 'templates/PageWrapper'
import Tabs from 'components/molecules/Tabs'
import DashboardTitle from 'components/molecules/DashboardTitle'
import ProfileSelector from 'components/molecules/ProfileSelector'

import dashboardBanner from 'assets/images/dashboard_banner.png'

const styles = theme => ({
  content: {
    backgroundColor: theme.palette.background.header,
  },
  header: {
    padding: `${theme.spacing(6)}px 0`,
  },
  tabs: {
    paddingBottom: theme.spacing(4),
  },
  bannerImage: {
    top: 0,
    right: 0,
    position: 'absolute',
  },
})

class AppHeader extends PureComponent {
  onTabClick = (tab) => {
    const newPath = tab.default || tab.path
    this.props.goTo(newPath)
  };

  render() {
    const {
      classes, location, headerLinks, organisation
    } = this.props

    const links = headerLinks.map((item) => {
      return { ...item.props }
    })

    return (
      <Fragment>
        {!organisation && <Redirect to={{ pathname: '/account/home' }} />}
        <Wrapper className={classes.content}>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            className={classes.header}>
            <DashboardTitle data={organisation} />
            <ProfileSelector />
          </Grid>
          <section className={classes.tabs}>
            <Tabs
              items={links}
              currentTab={location}
              onTabClick={this.onTabClick}
            />
          </section>
          <img
            className={classes.bannerImage}
            src={dashboardBanner}
            alt="App header banner | Goodnature"
          />
        </Wrapper>
      </Fragment>
    )
  }
}

AppHeader.propTypes = {
  goTo: PropTypes.func,
  classes: PropTypes.object,
  location: PropTypes.string,
  headerLinks: PropTypes.array,
  organisation: PropTypes.object,
}

export default withStyles(styles)(AppHeader)



// WEBPACK FOOTER //
// ./src/containers/core/AppHeader/AppHeader.js